import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'document',
  type: 'node--document_type',
  attributes: {
    name: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'title',
    },
  },
  relationships: {
    parent: {
      type: 'node--document_type',
      required: false,
      isArray: false,
      name: 'parent',
    },
  },
};
export const DocumentTypeService = createService(base, configuration, API_CONFIG.API);
export const DocumentTypeModule = createModule(DocumentTypeService, true);



// WEBPACK FOOTER //
// ./src/models/DocumentType.js